import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {capitalize} from "@pg-mono/nodash";
import {monthWhenVerbose, priceFormat} from "@pg-mono/string-utils";

import {PricesViewType} from "../../helpers/prices_view_type";
import {getAvgPricesText} from "../../utils/get_from_prices_type";
import {getFlatsRoomsText} from "../../utils/get_from_room_type";
import {getPercentMeaning, getPercentString, getPercentTrendVerb, getSignedPercentString} from "../../utils/percents_handling_helpers";
import {RoomsType} from "../PricesChart";

interface IProps {
    type: PricesViewType;
    roomsType: RoomsType;
    percentYearToYear?: number;
    percentMonthToMonth?: number;
    priceM2: number | undefined;
    medianPriceM2?: number;
    medianPercentYearToYear?: number;
    month: number;
    regionNameWhere: string;
    isVisible: boolean;
}

export const PricesChartDescriptionText = (props: IProps) => {
    const hasMedian = typeof props.medianPriceM2 === "number" && typeof props.medianPercentYearToYear === "number";

    return (
        <Text variant="body_copy_2" className={props.isVisible ? visibleStyle : hiddenStyle}>
            {`${capitalize(props.roomsType !== RoomsType.ONE_ROOM ? getAvgPricesText(props.type) : getAvgPricesText())} ${getFlatsRoomsText(props.roomsType)} ${
                props.regionNameWhere
            } w stanie deweloperskim w ${monthWhenVerbose(props.month)} wynoszą ${props.priceM2 ? priceFormat(props.priceM2) : "-"} za m`}
            <sup>2</sup>
            {typeof props.percentYearToYear === "number" &&
                typeof props.percentMonthToMonth === "number" &&
                `, co oznacza ${getPercentMeaning(props.percentYearToYear)} ${props.percentYearToYear != 0 ? `rzędu` : ""} ${getPercentString(
                    props.percentYearToYear
                )} rok do roku, a także ${getPercentMeaning(props.percentMonthToMonth)} ${getPercentString(
                    props.percentMonthToMonth
                )} względem ubiegłego miesiąca.`}
            {hasMedian && (
                <>
                    <br />
                    {`Mediana, czyli cena środkowa wynosi ${priceFormat(props.medianPriceM2 as number)} za m2 i ${getPercentTrendVerb(
                        props.medianPercentYearToYear as number
                    )} rok do roku (${getSignedPercentString(props.medianPercentYearToYear as number)}).`}
                </>
            )}
        </Text>
    );
};

const visibleStyle = css({
    display: "block"
});

const hiddenStyle = css({
    display: "none"
});
import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {capitalize} from "@pg-mono/nodash";
import {monthWhenVerbose, priceFormat} from "@pg-mono/string-utils";

import {PricesViewType} from "../../helpers/prices_view_type";
import {getAvgPricesText} from "../../utils/get_from_prices_type";
import {getFlatsRoomsText} from "../../utils/get_from_room_type";
import {getPercentMeaning, getPercentString, getPercentTrendVerb, getSignedPercentString} from "../../utils/percents_handling_helpers";
import {RoomsType} from "../PricesChart";

interface IProps {
    type: PricesViewType;
    roomsType: RoomsType;
    percentYearToYear?: number;
    percentMonthToMonth?: number;
    priceM2: number | undefined;
    medianPriceM2?: number;
    medianPercentYearToYear?: number;
    month: number;
    regionNameWhere: string;
    isVisible: boolean;
}

export const PricesChartDescriptionText = (props: IProps) => {
    const hasMedian = typeof props.medianPriceM2 === "number" && typeof props.medianPercentYearToYear === "number";

    return (
        <Text variant="body_copy_2" className={props.isVisible ? visibleStyle : hiddenStyle}>
            {`${capitalize(props.roomsType !== RoomsType.ONE_ROOM ? getAvgPricesText(props.type) : getAvgPricesText())} ${getFlatsRoomsText(props.roomsType)} ${
                props.regionNameWhere
            } w stanie deweloperskim w ${monthWhenVerbose(props.month)} wynoszą ${props.priceM2 ? priceFormat(props.priceM2) : "-"} za m`}
            <sup>2</sup>
            {typeof props.percentYearToYear === "number" &&
                typeof props.percentMonthToMonth === "number" &&
                `, co oznacza ${getPercentMeaning(props.percentYearToYear)} ${props.percentYearToYear != 0 ? `rzędu` : ""} ${getPercentString(
                    props.percentYearToYear
                )} rok do roku, a także ${getPercentMeaning(props.percentMonthToMonth)} ${getPercentString(
                    props.percentMonthToMonth
                )} względem ubiegłego miesiąca.`}
            {hasMedian && (
                <>
                    <br />
                    {`Mediana, czyli cena środkowa wynosi ${priceFormat(props.medianPriceM2 as number)} za m2 i ${getPercentTrendVerb(
                        props.medianPercentYearToYear as number
                    )} rok do roku (${getSignedPercentString(props.medianPercentYearToYear as number)}).`}
                </>
            )}
        </Text>
    );
};

const visibleStyle = css({
    display: "block"
});

const hiddenStyle = css({
    display: "none"
});
